module.exports = __webpack_public_path__ + "img/image_card_two.16f6bfdb.png";